import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=8bad1414"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=8bad1414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports